(function(){
  var root = document.querySelector('[data-ba]');
  if(!root) return;

  var compare      = root.querySelector('[data-compare]');
  var wrap         = root.querySelector('.ba-compare__wrap');
  var handle       = root.querySelector('[data-handle]');
  var beforeImg    = root.querySelector('[data-before-img]');
  var afterImg     = root.querySelector('[data-after-img]');
  var swatchesWrap = root.querySelector('[data-swatches]');

  if(!compare || !wrap || !handle || !beforeImg || !afterImg) return;

  (function(){
    var t = beforeImg.src;
    beforeImg.src = afterImg.src;
    afterImg.src = t;
  })();

  var dragging = false;
  var activePointerId = null;

  function clamp(n, min, max){ return Math.max(min, Math.min(max, n)); }

  function setByClientX(clientX){
    var rect = wrap.getBoundingClientRect();
    var p = (clientX - rect.left) / rect.width;
    p = clamp(p, 0.08, 0.92);
    root.style.setProperty('--ba-pos', (p * 100).toFixed(3) + '%');
  }

  function startDrag(e){
    dragging = true;
    activePointerId = e.pointerId;
    handle.classList.add('is-drag');
    try { wrap.setPointerCapture(activePointerId); } catch(err){}
    setByClientX(e.clientX);
    e.preventDefault();
  }

  function moveDrag(e){
    if(!dragging) return;
    if(activePointerId !== null && e.pointerId !== activePointerId) return;
    setByClientX(e.clientX);
    e.preventDefault();
  }

  function endDrag(e){
    if(!dragging) return;
    if(activePointerId !== null && e.pointerId !== activePointerId) return;
    dragging = false;
    activePointerId = null;
    handle.classList.remove('is-drag');
    try { wrap.releasePointerCapture(e.pointerId); } catch(err){}
    e.preventDefault();
  }

  wrap.addEventListener('pointerdown', startDrag);
  wrap.addEventListener('pointermove', moveDrag);
  wrap.addEventListener('pointerup', endDrag);
  wrap.addEventListener('pointercancel', endDrag);

  wrap.addEventListener('click', function(e){
    if(dragging) return;
    setByClientX(e.clientX);
  });

  function setActiveSwatch(setId){
    if(!swatchesWrap) return;
    swatchesWrap.querySelectorAll('.ba-swatch').forEach(function(b){
      if(b.getAttribute('data-set-id') === String(setId)) b.setAttribute('aria-current','true');
      else b.removeAttribute('aria-current');
    });
  }

  function swapImages(beforeUrl, afterUrl){
    var dur = 180;
    beforeImg.classList.add('is-fading');
    afterImg.classList.add('is-fading');
    window.setTimeout(function(){
      if(beforeUrl) beforeImg.src = beforeUrl;
      if(afterUrl)  afterImg.src  = afterUrl;
      window.setTimeout(function(){
        beforeImg.classList.remove('is-fading');
        afterImg.classList.remove('is-fading');
        root.style.setProperty('--ba-pos', '50%');
      }, 30);
    }, dur);
  }

  function activateSwatch(btn){
    var b = btn.getAttribute('data-before') || '';
    var a = btn.getAttribute('data-after')  || '';
    if(!b || !a) return false;
    if(btn.getAttribute('aria-current') === 'true') return true;
    setActiveSwatch(btn.getAttribute('data-set-id'));
    swapImages(a, b);
    return true;
  }

  // bring a swatch into view inside its own list only (never scrolls the page)
  function revealSwatch(btn){
    var vp = root.querySelector('[data-swatches-viewport]');
    if(!vp) return;
    var vr = vp.getBoundingClientRect();
    var br = btn.getBoundingClientRect();
    if(br.top < vr.top || br.bottom > vr.bottom){
      vp.scrollTop += (br.top - vr.top) - (vr.height - br.height) / 2;
    }
    if(br.left < vr.left || br.right > vr.right){
      vp.scrollLeft += (br.left - vr.left) - (vr.width - br.width) / 2;
    }
  }

  // before/after -> product page picker (sticky follows via the theme's variant-change event)
  function selectOnProduct(shade){
    if(!shade) return;
    var picker = document.querySelector("product-info[id^='MainProduct'] variant-picker");
    if(!picker) return;
    var inputs = picker.querySelectorAll('input[type="radio"]');
    for(var i = 0; i < inputs.length; i++){
      if(inputs[i].value === shade){
        if(inputs[i].checked) return;
        inputs[i].checked = true;
        picker.dispatchEvent(new Event('change'));
        return;
      }
    }
  }

  root.querySelectorAll('.ba-swatch').forEach(function(btn){
    btn.addEventListener('click', function(e){
      e.preventDefault();
      e.stopPropagation();
      if(!activateSwatch(btn)) return;
      selectOnProduct(btn.getAttribute('data-shade'));
    });
  });

  // product page / sticky -> before/after
  function syncFromVariant(v){
    if(!v || !v.sku) return;
    var list = root.querySelectorAll('.ba-swatch');
    for(var i = 0; i < list.length; i++){
      if(list[i].getAttribute('data-set-id') === String(v.sku)){
        if(activateSwatch(list[i])) revealSwatch(list[i]);
        return;
      }
    }
  }

  document.addEventListener('variant:changed', function(e){
    syncFromVariant(e && e.detail && e.detail.variant);
  });

  // on load: show the shade that is selected on the product page (e.g. ?variant=...)
  (function(){
    var node = document.querySelector("product-info[id^='MainProduct'] variant-picker [data-selected-variant]");
    if(!node) return;
    try { syncFromVariant(JSON.parse(node.textContent)); } catch(err){}
  })();

  var swWrapper  = root.querySelector('[data-swatches-wrapper]');
  var swViewport = root.querySelector('[data-swatches-viewport]');
  var btnUp      = swWrapper && swWrapper.querySelector('.ba-snav--up');
  var btnDown    = swWrapper && swWrapper.querySelector('.ba-snav--down');
  var SWATCH_SIZE = 44;
  var SWATCH_GAP  = 14;
  var STEP = SWATCH_SIZE + SWATCH_GAP;

  function isDesktop(){ return window.innerWidth > 900; }

  // mobile: do all swatches fit in one row without scrolling?
  function swatchesFitRow(){
    var list = swViewport.querySelectorAll('.ba-swatch');
    if(!list.length) return false;
    var first = list[0].getBoundingClientRect();
    var last  = list[list.length - 1].getBoundingClientRect();
    return (last.right - first.left + 16) <= swViewport.clientWidth;
  }

  function updateSwNav(){
    if(!swViewport || !btnUp || !btnDown || !swWrapper) return;
    if(!isDesktop()){
      swWrapper.classList.remove('has-overflow');
      swWrapper.classList.toggle('is-fit', swatchesFitRow());
      return;
    }
    swWrapper.classList.remove('is-fit');
    var hasOverflow = swViewport.scrollHeight > swViewport.clientHeight + 2;
    swWrapper.classList.toggle('has-overflow', hasOverflow);
    btnUp.classList.toggle('is-disabled',   swViewport.scrollTop <= 2);
    btnDown.classList.toggle('is-disabled', swViewport.scrollTop + swViewport.clientHeight >= swViewport.scrollHeight - 2);
  }

  if(swViewport && btnUp && btnDown){
    btnUp.addEventListener('click', function(){
      swViewport.scrollBy({ top: -STEP, behavior: 'smooth' });
      setTimeout(updateSwNav, 320);
    });
    btnDown.addEventListener('click', function(){
      swViewport.scrollBy({ top: STEP, behavior: 'smooth' });
      setTimeout(updateSwNav, 320);
    });

    swViewport.addEventListener('scroll', updateSwNav, { passive: true });

    var swDragging = false, swStartY = 0, swScrollStart = 0;

    swViewport.addEventListener('mousedown', function(e){
      if(!isDesktop()) return;
      swDragging = true;
      swStartY = e.pageY - swViewport.getBoundingClientRect().top;
      swScrollStart = swViewport.scrollTop;
      swViewport.style.cursor = 'grabbing';
    });
    document.addEventListener('mouseup', function(){
      swDragging = false;
      if(swViewport) swViewport.style.cursor = '';
    });
    document.addEventListener('mousemove', function(e){
      if(!swDragging || !isDesktop()) return;
      e.preventDefault();
      var y = e.pageY - swViewport.getBoundingClientRect().top;
      swViewport.scrollTop = swScrollStart - (y - swStartY) * 1.5;
    });

    window.addEventListener('resize', updateSwNav);
    updateSwNav();
    setTimeout(updateSwNav, 200);
  }
})();